// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__TsuNq","container":"styles_container__16XKG","title":"styles_title__1_HeP","wrapper":"styles_wrapper__2qwYf","answer":"styles_answer__1VfH_"};